<template>
  <div class="page-wrapper">
    <AppHeader title="Machines" />
    <div class="container-fluid">
    <Void
      :open="isVoidOpen"
      @getVoidPermission="setVoidPermission($event)"
      @close="isVoidOpen = !isVoidOpen"
    />
    <div class="container-fluid left">
      <div class="row topnav" style="padding-left: 15px">
        <!-- <div class="col-sm-1">
          <div
            class="dropdown"
            style="
              position: fixed;
              left: 0;
              top: 0;
              padding: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            <MainMenu />
          </div>
        </div> -->
        <div class="col-sm-12">
          <div v-show="showError" style="text-align: center">
            <label class="h3" style="color: maroon">
              {{ this.mainErrorMsg }}
            </label>
          </div>
        </div>
      </div>
      <div v-if="showAddPromotion" style="width: 100%; display: flex; justify-content: center;">
        <div class="card shadow-lg" style="background-color: var(--form-color); padding: 30px; border-radius: 15px; width: 100%; max-width: 600px; color: var(--theme-text-main);">
          <div class="form-group mb-3">
            <label title="name" style="font-size: 1.2em; display: block; margin-bottom: 5px;">Machine Name</label>
            <input
              type="text"
              v-model="name"
              class="form-control input-lg"
              style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);"
            />
          </div>

          <div class="form-group mb-3">
            <label title="ip" style="font-size: 1.2em; display: block; margin-bottom: 5px;">Ip</label>
            <input
              type="text"
              v-model="ip"
              class="form-control input-lg"
              style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);"
            />
          </div>

          <div style="text-align: right; margin-top: 20px; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 20px;">
            <button
              class="btn btn-danger btn-lg"
              style="font-size: 1.2em; margin-right: 10px;"
              @click="cancelSavePromotion"
            >
              Cancel
            </button>
            <button
              class="btn btn-success btn-lg"
              v-if="machineId === -1"
              style="font-size: 1.2em;"
              @click="createMachine"
            >
              Save
            </button>
            <button
              class="btn btn-success btn-lg"
              v-if="machineId !== -1"
              style="font-size: 1.2em;"
              @click="updateMachine"
            >
              Update
            </button>
          </div>
        </div>
      </div>
      <div v-if="toggle">

        <div class="touch-search-header">
          <div class="touch-search-area">
            <div class="input-group touch-search-group">
              <span class="input-group-addon">
                <i class="glyphicon glyphicon-search"></i>
              </span>
              <input
                type="text"
                v-model="searchMachine"
                class="form-control input-lg"
                placeholder="Search machines"
                @keyup.enter="applyMachineSearch()"
              />
              <span class="input-group-btn">
                <button class="btn btn-success btn-lg" @click="applyMachineSearch()">
                  Search
                </button>
              </span>
            </div>
          </div>
          <div class="touch-search-actions">
            <button
              class="btn btn-success btn-lg"
              v-if="hasPermission(49)"
              @click="handleAddMachine"
            >
              New Machine
            </button>
          </div>
        </div>
        <br>
        <div
          v-if="toggle"
          class="row table-wrap"
          style="color: #fff; "
        >
          <table class="table" style="color: #fff">
            <thead>
              <tr>
                <th style="font-size: 1.2em">Machine Name</th>
                <th style="font-size: 1.2em">Ip</th>
                <th style="font-size: 1em"></th>
                <th style="font-size: 1em"></th>
                <!-- <th style="font-size: 1.5em"></th>
                <th style="font-size: 1.5em"></th>
                <th style="font-size: 1.5em"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="machine in filteredMachines" :key="machine.id">
                <td style="font-size: 1.2em">{{ machine.name }}</td>
                <td style="font-size: 1.2em">{{ machine.ip }}</td>
                <td>
                  <button
                    v-if="hasPermission(50)"
                    class="btn btn-success"
                    style="font-size: 1em"
                    @click="editMachine(machine)"
                  >
                    Edit
                  </button>
                </td>
                <td>
                  <button
                    v-if="hasPermission(51)"
                    class="btn btn-danger"
                    style="font-size: 1em"
                    @click="deleteMachine(machine)"
                  >
                    Delete
                  </button>
                </td>
                <!-- <td style="font-size: 1.5em"></td>
                <td style="font-size: 1.5em"></td>
                <td style="font-size: 1.5em"></td>
                <td style="font-size: 1.5em"></td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import MainMenu from "@/components/MainMenu";
import AppHeader from "@/components/AppHeader";
import Datepicker from "vuejs3-datepicker";
import "vue-date-pick/dist/vueDatePick.css";
import Void from "@/components/Void";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      modules: "modules_options/modulesPers",
      machinePermissions: "modules_options/machinePermissions",
    }),
    filteredMachines() {
      let list = this.allMachines || [];
      const search = (this.searchMachine || "").toLowerCase();

      if (search) {
        list = list.filter((m) => {
          const name = (m.name || "").toLowerCase();
          const ip = (m.ip || "").toLowerCase();
          const id = (m.id || "").toString().toLowerCase();
          return name.includes(search) || ip.includes(search) || id.includes(search);
        });
      }

      return list;
    },
  },
  mixins: [commonServices],
  mounted() {
    this.getAllMachines();
    if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
    } else {
      this.$router.push({ name: "login" });
    }
    this.language = "ar";
    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  components: { MainMenu, Datepicker, Void, AppHeader },
  data: function () {
    return {
      modulePermissions: [],
      state: { start_date: new Date(2016, 9, 16) },
      stateEnd: { end_date: new Date(2016, 9, 16) },
      showAddPromotion: false,
      showDuplicatePromotion: false,
      showPermissions: false,
      promotions: [],
      allMachines: [],
      searchMachine: "",
      machineJson: {},
      promotionJson: {},
      promotionInfos: {},
      machineId: -1,
      promoition_name: "",
      start_date: "",
      end_date: "",
      minimum_total: "",
      percentage: "",
      name: "",
      authorizedToChangePrice: "N",
      isVoidOpen: false,
      ip: "",
      repeat_ip: "",
      reports_ok: false,
      showError: false,
      logoImage: "",
      mainErrorMsg: "",
      logoUrl: "",
      jsonData: {},
      language: "en",
      languageName: "",
      toggle: true,
      showInvoices: false,
      showPayments: false,
      addresses: [],
      selectedcustomers: [],
      customer_invoices: [],
      customer_payments: [],
      customersJson: {},
      name: "",
      gender: "",
      email: "",
      phone: "",
      totalpoints: "",
      dis_percentage: "",
      status: "",
      creditstatus: "",
      date_added: "",
      aaddressid: 0,
      addressLine1: "",
      addressLine2: "",
      addressArea: "",
      addressCity: "",
      isDefault: false,
      customerAddresses: [],
      showAddress: false,
      findcustomer: "",
      findcustomername: "",
      customeraddress: {},
      machinePerms: [],
    };
  },
  methods: {
    applyMachineSearch() {
      this.searchMachine = (this.searchMachine || "").trim();
    },
    async setVoidPermission(authorizedToChangePrice) {
      if (authorizedToChangePrice === "Y") {
        this.machineJson.appId = localStorage.appId;
        this.machineJson.id = this.machineId;

        try {
          let dataURL = this.apiURL + "Machines/deleteMachine";
          let response = await axios.post(dataURL, this.machineJson);
          if (response.data.status === "success") {
            this.showSuccess("Machine Deleted Successfully!");
            this.getAllMachines();
            this.cancelSavePromotion();
          } else {
            this.showAlert("Error Happened Please Check Entered Data!");
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        // Error message mo permission
      }
      this.authorizedToChangePrice = "N";
    },
    editMachine(machine) {
      this.name = machine.name;
      this.ip = machine.ip;

      this.machineId = machine.id;
      this.toggle = false;
      this.showAddPromotion = true;
    },
    duplicateMachine(machine) {
      this.name = machine.name;
      this.machineId = machine.id;

      this.toggle = false;
      this.showAddPromotion = false;
      this.showDuplicatePromotion = true;
    },
    deleteMachine: function (machine) {
      this.isVoidOpen = true;
      this.machineId = machine.id;
    },
    createMachine: async function () {
      if (this.ip == "" || this.name == "") {
        this.showAlert("Please Fill All fields!");
        return;
      }
      this.machineJson.appId = localStorage.appId;
      this.machineJson.name = this.name;
      this.machineJson.ip = this.ip;
      try {
        let dataURL = this.apiURL + "Machines/createMachine";
        let response = await axios.post(dataURL, this.machineJson);
        if (response.data.status === "success") {
          this.showSuccess("Machine Added Successfully!");
          this.getAllMachines();
          this.handleAddMachine();
          this.cancelSavePromotion();
        } else {
          this.showAlert("Error Happened Please Check Entered Data!");
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancelSavePromotion() {
      this.toggle = true;
      this.showAddPromotion = false;
      this.showPermissions = false;
      this.showDuplicatePromotion = false;
    },
    updateMachine: async function () {
      if (this.ip == "" || this.name == "") {
        this.showAlert("Please Fill All fields!");
        return;
      }
      this.machineJson.appId = localStorage.appId;
      this.machineJson.id = this.machineId;
      this.machineJson.name = this.name;
      this.machineJson.ip = this.ip;

      try {
        let dataURL = this.apiURL + "Machines/updateMachine";
        let response = await axios.post(dataURL, this.machineJson);
        if (response.data.status === "success") {
          this.showSuccess("Machine Updated Successfully!");
          this.getAllMachines();
          this.cancelSavePromotion();
        } else {
          this.showAlert("Error Happened Please Check Entered Data!");
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleAddMachine: async function () {
      this.showAddPromotion = true;
      this.machineId = -1;
      this.name = "";
      this.ip = "";
      this.ura = "";
      this.repeat_ip = "";
      this.showError = false;
      this.mainErrorMsg = "";
      this.showAddCustomer = true;
      this.toggle = false;
    },

    getAllMachines: async function () {
      this.machineJson.appId = localStorage.appId;
      try {
        let dataURL = this.apiURL + "Machines/getAllMachines";
        let response = await axios.post(dataURL, this.machineJson);
        if (response.data.status === "success") {
          this.allMachines = response.data.results;
        }
      } catch (error) {
        console.log(error);
      }
      return this.allMachines;
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}

.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}

.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}

.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}

.check-label {
  color: #fff;
  font-size: 1.5rem;
  margin-left: 1rem;
  margin: 1rem 0;
}
</style>
